import React, { useState, useEffect } from 'react';  // eslint-disable-line
import { useLocation } from 'react-router-dom';
import CompletionPrompt from '../components/CompletionPrompt';
import MonitorPromptSample from '../components/MonitorPromptSample';

function PromptRow({ prompt, onSelect }) {
  const cutoff = prompt.output.length > 20;
  const maybeDots = cutoff ? '...' : '';

  return (
    <tbody>
      <tr>
        <td>{prompt.name}</td>
        <td>
          <button
            onClick={() => onSelect(prompt)}>
            {prompt.prompt_sid}
          </button>
        </td>
        <td>{prompt.utc_timestamp}</td>
        <td>{prompt.model}</td>
        <td>{prompt.output.slice(0, 20) + maybeDots}</td>
      </tr>
    </tbody>
  )
}

function PromptsListView({ prompts, onSelect }){
  const rows = prompts.map((prompt) => {
      return <PromptRow
        key={prompt.prompt_sid}
        prompt={prompt}
        onSelect={onSelect}/>;
    });
  return(
    <div className="playbooks-view">
      <table>
        <tbody>
          <tr className="playbooks-view-header">
            <th>Name</th>
            <th>Prompt SID</th>
            <th>UTC Timestamp</th>
            <th>Model</th>
            <th>Output Preview</th>
          </tr>
        </tbody>
        {rows}
      </table>
    </div>
  )
}

export default function Monitor() {
  const [selectedPromptSID, setselectedPromptSID] = useState(null);
  const [prompt, setPrompt] = useState('');
  const [lm_log, setLMLog] = useState('');
  const [prompts, setPrompts] = useState([]);
  const [model, setModel] = useState(null);
  const [output, setOutput] = useState(null);
  const [botSessionSID, setBotSessionSID] = useState('');
  const [taskSID, setTaskSID] = useState(null);
  const location = useLocation();
  function onSelect(item) {
    setPrompt(item.text_input);
    setLMLog(item.lm_log);
    setModel(item.model);
    setOutput(item.output);
    setModel(item.model);
    setselectedPromptSID(item.prompt_sid);

  const params = new URLSearchParams(window.location.search);
  if (item.bot_session_sid) {
    params.set("bot_session_sid", item.bot_session_sid);
  } else if (botSessionSID) {
    params.set("bot_session_sid", botSessionSID);
  }
  if (item.task_sid) {
    params.set("task_sid", item.task_sid);
  } else if (item.prompt_sid) {
    params.set("task_sid", item.prompt_sid);
  }

  const newUrl = window.location.pathname + "?" + params.toString();
  window.history.replaceState({}, '', newUrl);

  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const botSID = searchParams.get('bot_session_sid');
    const taskSID = searchParams.get('task_sid');

    const isEmpty = (str) => (str === "" || str == null);

    // Don't allow for prompt fetching from URL unless either the bot SID
    // or task SID is non-empty
    if (isEmpty(botSID) && isEmpty(taskSID)) {
      return;
    }

    setTaskSID(taskSID || '');
    setBotSessionSID(botSID || '');

    fetchPrompts(botSID, taskSID);
  }, [location.search]);


  async function fetchPrompts(botSID, taskSIDFromURL = null) {
  const loadingEl = document.getElementById('loading-message');
  loadingEl?.style.removeProperty("display");

  let backendUrl = process.env.NODE_ENV === 'development'
    ? 'http://localhost:8001/'
    : '';
  
  const query = [];
  if (botSID) query.push(`bot_session_sid=${botSID}`);
  backendUrl += "bot_session_prompts?" + query.join('&');

  try {
    let response = await fetch(backendUrl);
    response = await response.json();

    setPrompts(response.prompts);
    setBotSessionSID(response.bot_session_sid);

    if (taskSIDFromURL && response.prompts?.length > 0) {
      const match = response.prompts.find(p =>
        p.task_sid === taskSIDFromURL || p.prompt_sid === taskSIDFromURL
      );
      if (match) {
        onSelect(match);
      }
    }

    const params = new URLSearchParams();
    if (botSID) params.set("bot_session_sid", botSID);
    if (taskSIDFromURL) params.set("task_sid", taskSIDFromURL);

    const newUrl = window.location.pathname + "?" + params.toString();
    window.history.replaceState({}, '', newUrl);

  } catch (err) {
    console.error("Failed to fetch prompts:", err);
  } finally {
    loadingEl.style.display = "none";
  }
}



  return (
    <div>
      <CompletionPrompt />
      <div id="query-area">
        <div>
          <input
            name='bot-session-sid'
            placeholder='bot session sid'
            value={botSessionSID}
            onChange={x => setBotSessionSID(x.target.value)}
            />
        </div>
        <div>
          <button onClick={() => fetchPrompts(botSessionSID, taskSID)}>
            Get prompts
          </button>
        </div>
        <div>
          <input
            name='task-id'
            placeholder='task sid'
            onChange={x => setTaskSID(x.target.value)}
            />
        </div>
        <div>
          <button onClick={() => fetchPrompts(botSessionSID, taskSID)}>
            Get prompts by task sid
          </button>

        </div>
        When you hit the button, the prompts will appear below.
      </div>
      <div id="loading-message" style={{ "display": "none" }}>
        Gathering results...
      </div>
      { prompts && prompts.length &&
        <PromptsListView
          onSelect={onSelect}
          prompts={prompts}
        />
      }
      <LLMsPage
        prompt_sid={selectedPromptSID}
        prompt={prompt}
        lm_log={lm_log}
        model={model}
        output={output}
      />
    </div>
  );
}

function LLMsPage({prompt, lm_log, model, output, prompt_sid}) {
  return (
    <>
      <MonitorPromptSample
        prompt={prompt}
        lm_log={lm_log}
      />
      model: {model} <br/>
      output: {output} <br/>
      prompt_sid: {prompt_sid}
    </>
  );
}
